import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { dashboardZone, addDashboard } from "../api";
import {
  setDashboardZone,
  setDashboardDetails,
  setNewDashboard,
} from "../redux";
import { Col } from "reactstrap";
import { withRouter } from "react-router-dom";
import ShortcutModal from "./ShortcutModal";
import { AddDetails, Alert } from "./";
import { useTranslation } from "react-i18next";
import { FiHome, FiPlus, FiTrash2, FiSave, FiArrowLeft } from "react-icons/fi";

const AddComp = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );

  const [activeDash, setActiveDash] = useState(false);
  const [showAddZone, setShowAddZone] = useState(false);
  let [activeIndex, setActiveIndex] = useState(0);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    id: "",
    request: "",
  });
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  useEffect(() => {
    setActiveDash(true);
    setShowAddZone(false);
  }, []);

  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    setActiveDash(true);
    setShowAddZone(false);
    const formData = new FormData();
    formData.append("dashboard", value.id);
    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));
        dispatch(setDashboardZone(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const form = useRef(null);
  const initialValues = {
    caption: "",
  };

  const submitForm = () => {
    const formData = new FormData(form.current);
    addDashboard(formData, token)
      .then((res) => {
        form.current.reset();
        dispatch(
          setNewDashboard({
            id: res.data.data,
            dashboard_caption: formData.get("caption"),
          })
        );
        setShowAlert({
          show: true,
          message: t("خانه جدید با موفقیت اضافه شد."),
          type: "Success",
          question: false,
        });
        setTimeout(() => {
          toggleAlert();
        }, 5000);
        setShowAddZone(false);
        setActiveDash(true);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchema = Yup.object({
    caption: Yup.string().required(t("نام ساختمان را وارد کنید.")),
  });

  const deleteDashboard = async (id) => {
    let countDevice = 0;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    try {
      var formdata = new FormData();
      formdata.append("dashboard", id);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let response = await fetch(
        "https://assessn.mmaviot.com/api/dashboard_zones",
        requestOptions
      );
      let result = await response.json();

      for (const zone of result.data) {
        let formdataZone = new FormData();
        formdataZone.append("zone", zone.id);
        let requestOptionsZone = {
          method: "POST",
          headers: myHeaders,
          body: formdataZone,
          redirect: "follow",
        };

        let responseZone = await fetch(
          "https://assessn.mmaviot.com/api/zone_widgets",
          requestOptionsZone
        );
        let resultZone = await responseZone.json();

        if (resultZone.data.length !== 0) {
          countDevice++;
        }
      }

      if (countDevice === 0) {
        setShowAlert({
          show: true,
          message: t("آیا از حذف این ساختمان اطمینان دارید؟"),
          type: "Warning",
          question: true,
          id: id,
          request: "dashboard",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 10000);
      } else {
        setShowAlert({
          show: true,
          message: t(
            "این ساختمان حاوی دستگاه است! ابتدا دستگاه مربوطه حذف گردد."
          ),
          type: "Warning",
          question: false,
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 10000);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      <h2 className="setting-title">{t("ساختمان جدید")}</h2>

      {/* Dashboard List */}
      <div className="dashboard-list-section">
        <div className="dashboard-list">
          {dashboardMine?.map((dash, index) => {
            const isActive = activeIndex === index;
            return (
              <div key={index} className="dashboard-item">
                <div
                  className={`dashboard-item-content ${isActive ? "active" : ""}`}
                  onClick={() => dashboardDetail(dash, index)}
                >
                  <div className="dashboard-item-icon">
                    <FiHome size={16} />
                  </div>
                  <span className="dashboard-item-name">{dash.dashboard_caption}</span>
                </div>
                <button
                  className="dashboard-delete-btn"
                  onClick={() => deleteDashboard(dash.id)}
                  title={t("حذف ساختمان")}
                >
                  <FiTrash2 size={14} />
                </button>
              </div>
            );
          })}
          
          {/* Add New Dashboard Button */}
          <div
            className="dashboard-add-item"
            onClick={() => {
              setActiveDash(false);
              setShowAddZone(true);
            }}
          >
            <div className="dashboard-add-icon">
              <FiPlus size={18} />
            </div>
            <span className="dashboard-add-text">{t("ساختمان جدید")}</span>
          </div>
        </div>
      </div>

      {/* Add Details Section */}
      {activeDash && <AddDetails />}

      {/* Add New Dashboard Form */}
      {showAddZone && (
        <Formik
          initialValues={initialValues}
          onSubmit={submitForm}
          validationSchema={validationSchema}
        >
          {(formProps) => (
            <Form ref={form}>
              <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
                <div className="setting-item-label">
                  <FiHome size={16} />
                  <span>{t("نام ساختمان")}</span>
                </div>
                <input
                  type="text"
                  autoFocus
                  value={formProps.values.caption || ""}
                  placeholder={t("نام ساختمان را وارد کنید.")}
                  className="setting-input"
                  name="caption"
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                />
                <ErrorMessage name="caption">
                  {(errMsg) => <div className="setting-error">{errMsg}</div>}
                </ErrorMessage>
              </div>

              <div className="setting-buttons">
                <button
                  type="button"
                  className="setting-back-btn"
                  onClick={() => {
                    setShowAddZone(false);
                    setActiveDash(true);
                  }}
                  style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
                >
                  <FiArrowLeft size={18} />
                  <span>{t("انصراف")}</span>
                </button>
                <button type="submit" className="setting-back-btn">
                  <FiSave size={18} />
                  <span>{t("تائید")}</span>
                </button>
              </div>
            </Form>
          )}
        </Formik>
      )}

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          id={showAlert.id}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
      
      {/* <ShortcutModal /> */}
    </div>
  );
};

const Add = withRouter(AddComp);

export { Add };